import {closeWizard, postPayload, setPasswordEnabled} from "../data";
import uuid4 from "uuid4";
import {postResync} from "../status";
import fetch from "cross-fetch";

import _debounce from "lodash/debounce";

export const INITIALIZE_APP_V2_WIZARD = 'INITIALIZE_APP_V2_WIZARD';
export const APP_V2_WIZARD_NEXT = 'APP_V2_WIZARD_NEXT';
export const WIZARD_DONE_LOADING = 'WIZARD_DONE_LOADING';
export const WIZARD_PUBLISHING_OFFER = 'WIZARD_PUBLISHING_OFFER';
export const APP_V2_WIZARD_BACK = 'APP_V2_WIZARD_BACK';
export const WIZARD_TOGGLE_NEED_HELP_MODAL = 'WIZARD_TOGGLE_NEED_HELP_MODAL';
export const TOGGLE_CONTACT_US_MODAL = 'TOGGLE_CONTACT_US_MODAL';
export const TOGGLE_CROSS_SELL_VIDEO_MODAL = 'TOGGLE_CROSS_SELL_VIDEO_MODAL';
export const TOGGLE_BUNDLE_VIDEO_MODAL = 'TOGGLE_BUNDLE_VIDEO_MODAL';
export const TOGGLE_VOLUME_DISCOUNT_VIDEO_MODAL = 'TOGGLE_VOLUME_DISCOUNT_VIDEO_MODAL';
export const TOGGLE_MIX_AND_MATCH_VIDEO_MODAL = 'TOGGLE_MIX_AND_MATCH_VIDEO_MODAL';
export const TOGGLE_SELECT_PRODUCTS_MODAL = 'TOGGLE_SELECT_PRODUCTS_MODAL';
export const TOGGLE_CROSS_SELL_SELECT_PRODUCTS_MODAL = 'TOGGLE_CROSS_SELL_SELECT_PRODUCTS_MODAL';
export const TOGGLE_SELECT_COLLECTIONS_MODAL = 'TOGGLE_SELECT_COLLECTIONS_MODAL';
export const TOGGLE_CROSS_SELL_SELECT_COLLECTIONS_MODAL = 'TOGGLE_CROSS_SELL_SELECT_COLLECTIONS_MODAL';
export const TOGGLE_MNM_SELECT_COLLECTIONS_MODAL = 'TOGGLE_MNM_SELECT_COLLECTIONS_MODAL';
export const TOGGLE_SELECT_TAGS_MODAL = 'TOGGLE_SELECT_TAGS_MODAL';
export const TOGGLE_CROSS_SELL_SELECT_TAGS_MODAL = 'TOGGLE_CROSS_SELL_SELECT_TAGS_MODAL';
export const APPROVE_SELECTED_PRODUCTS = 'APPROVE_SELECTED_PRODUCTS';
export const APPROVE_CROSS_SELL_SELECTED_PRODUCTS = 'APPROVE_CROSS_SELL_SELECTED_PRODUCTS';
export const APPROVE_SELECTED_COLLECTIONS = 'APPROVE_SELECTED_COLLECTIONS';
export const APPROVE_CROSS_SELL_SELECTED_COLLECTIONS = 'APPROVE_CROSS_SELL_SELECTED_COLLECTIONS';
export const APPROVE_MNM_SELECTED_COLLECTIONS = 'APPROVE_MNM_SELECTED_COLLECTIONS';
export const APPROVE_SELECTED_TAGS = 'APPROVE_SELECTED_TAGS';
export const APPROVE_CROSS_SELL_SELECTED_TAGS = 'APPROVE_CROSS_SELL_SELECTED_TAGS';
export const WIZARD_VOLUME_ADD_TIER = 'WIZARD_VOLUME_ADD_TIER';
export const SELECT_OFFER_TYPE = 'SELECT_OFFER_TYPE';
export const SELECT_BUNDLE_TYPE = 'SELECT_BUNDLE_TYPE';
export const WIZARD_SELECT_MNM_DISCOUNT_TYPE = 'WIZARD_SELECT_MNM_DISCOUNT_TYPE';
export const SELECT_PAGE_TYPE = 'SELECT_PAGE_TYPE';
export const APP_V2_WIZARD_SELECT_OFFER_PLACEMENT_METHOD = 'APP_V2_WIZARD_SELECT_OFFER_PLACEMENT_METHOD';
export const SELECT_TRIGGER = 'SELECT_TRIGGER';
export const SELECT_CONTENT_TYPE = 'SELECT_CONTENT_TYPE';
export const UPDATE_PRODUCT_SEARCH_TEXT = 'UPDATE_PRODUCT_SEARCH_TEXT';
export const UPDATE_COLLECTION_SEARCH_TEXT = 'UPDATE_COLLECTION_SEARCH_TEXT';
export const UPDATE_TAG_SEARCH_TEXT = 'UPDATE_TAG_SEARCH_TEXT';
export const WIZARD_BUNDLE_AMOUNT_CHANGE = 'WIZARD_BUNDLE_AMOUNT_CHANGE';
export const WIZARD_MNM_DISCOUNT_AMOUNT_CHANGE = 'WIZARD_MNM_DISCOUNT_AMOUNT_CHANGE';
export const WIZARD_MNM_MIN_QTY_CHANGE = 'WIZARD_MNM_MIN_QTY_CHANGE';
export const WIZARD_MNM_TRASH_PRODUCT_GROUP = 'WIZARD_MNM_TRASH_PRODUCT_GROUP';
export const WIZARD_VOLUME_QTY_CHANGE = 'WIZARD_VOLUME_QTY_CHANGE';
export const WIZARD_VOLUME_DISCOUNT_TYPE_CHANGE = 'WIZARD_VOLUME_DISCOUNT_TYPE_CHANGE';
export const WIZARD_VOLUME_DISCOUNT_CHANGE = 'WIZARD_VOLUME_DISCOUNT_CHANGE';
export const WIZARD_VOLUME_POPULAR_CHANGE = 'WIZARD_VOLUME_POPULAR_CHANGE';
export const WIZARD_VOLUME_TRASH_TIER = 'WIZARD_VOLUME_TRASH_TIER';
export const SET_SEARCHED_PRODUCTS = 'SET_SEARCHED_PRODUCTS';
export const WIZARD_SET_TRIGGER_STAGE_UUID = 'WIZARD_SET_TRIGGER_STAGE_UUID';
export const WIZARD_SET_OFFER_STAGE_UUID = 'WIZARD_SET_OFFER_STAGE_UUID';
export const WIZARD_SET_FINALIZE_OFFER_START_TIME = 'WIZARD_SET_FINALIZE_OFFER_START_TIME';
export const WIZARD_SET_TRIGGER_STAGE_READY = 'WIZARD_SET_TRIGGER_STAGE_READY';
export const WIZARD_SET_OFFER_STAGE_READY = 'WIZARD_SET_OFFER_STAGE_READY';
export const SET_BUNDLE_SEARCHED_PRODUCTS = 'SET_BUNDLE_SEARCHED_PRODUCTS';
export const SET_SEARCHED_COLLECTIONS = 'SET_SEARCHED_COLLECTIONS';
export const SET_ALL_TAGS = 'SET_ALL_TAGS';
export const SET_SEARCHED_TAGS = 'SET_SEARCHED_TAGS';
export const TOGGLE_SELECT_PRODUCT = 'TOGGLE_SELECT_PRODUCT';
export const TOGGLE_SELECT_COLLECTION = 'TOGGLE_SELECT_COLLECTION';
export const TOGGLE_SELECT_TAG = 'TOGGLE_SELECT_TAG';
export const REMOVE_SELECTED_PRODUCT = 'REMOVE_SELECTED_PRODUCT';
export const REMOVE_SELECTED_COLLECTION = 'REMOVE_SELECTED_COLLECTION';
export const REMOVE_SELECTED_TAG = 'REMOVE_SELECTED_TAG';
export const WIZARD_BUNDLE_SELECT_PRODUCT = 'WIZARD_BUNDLE_SELECT_PRODUCT';
export const WIZARD_CHOOSE_BUNDLE_PRODUCT = 'WIZARD_CHOOSE_BUNDLE_PRODUCT';
export const WIZARD_BUNDLE_REMOVE_PRODUCT = 'WIZARD_BUNDLE_REMOVE_PRODUCT';
export const SENDING_SUPPORT_REQUEST = 'SENDING_SUPPORT_REQUEST';
export const WIZARD_SET_INVALID_SELECT_PAGE = 'WIZARD_SET_INVALID_SELECT_PAGE';
export const WIZARD_SET_INVALID_SELECT_TRIGGER = 'WIZARD_SET_INVALID_SELECT_TRIGGER';
export const WIZARD_SET_INVALID_SELECT_OFFER = 'WIZARD_SET_INVALID_SELECT_OFFER';
export const WIZARD_BUNDLE_CLOSE_SELECT_PRODUCTS_MODAL = 'WIZARD_BUNDLE_CLOSE_SELECT_PRODUCTS_MODAL';
export const WIZARD_BUNDLE_ADD_PRODUCT = 'WIZARD_BUNDLE_ADD_PRODUCT';
export const WIZARD_STATUS = 'WIZARD_STATUS';
export const WIZARD_PREVIEW_READY = 'WIZARD_PREVIEW_READY';
export const WIZARD_CREATE_ANOTHER_OFFER = 'WIZARD_CREATE_ANOTHER_OFFER';
export const WIZARD_COLLECTIONS_ARE_UPLOADED = 'WIZARD_COLLECTIONS_ARE_UPLOADED';
export const WIZARD_TOGGLE_PLACEMENT_METHOD_COLLAPSIBLE = 'WIZARD_TOGGLE_PLACEMENT_METHOD_COLLAPSIBLE';
export const WIZARD_SHOW_FALLBACK = 'WIZARD_SHOW_FALLBACK';
export const WIZARD_SET_CREATE_STORE_JS_UUID = 'WIZARD_SET_CREATE_STORE_JS_UUID';
export const WIZARD_PREVIEW_PROGRESS = 'WIZARD_PREVIEW_PROGRESS';
export const WIZARD_SET_OFFER_ATTRIBUTES = 'WIZARD_SET_OFFER_ATTRIBUTES';
export const SET_OFFER_PLACEMENT_AND_OS2 = 'SET_OFFER_PLACEMENT_AND_OS2';
export const SET_ENABLE_ZOORIX_MODAL_OPEN = 'SET_ENABLE_ZOORIX_MODAL_OPEN';
export const WIZARD_SET_ZOORIX_ENABLED_LOADING = 'WIZARD_SET_ZOORIX_ENABLED_LOADING';
export const WIZARD_ENABLING_ZOORIX = 'WIZARD_ENABLING_ZOORIX';
export const WIZARD_SET_ZOORIX_ENABLED = 'WIZARD_SET_ZOORIX_ENABLED';
export const WIZARD_SET_OFFER_CREATION_TIMEOUT_ID = 'WIZARD_SET_OFFER_CREATION_TIMEOUT_ID';
export const FETCH_PRODUCTS_COMPLETE = 'FETCH_PRODUCTS_COMPLETE';

export const initializeAppV2Wizard = json => ({
    type: INITIALIZE_APP_V2_WIZARD,
    json,
});

export const appV2WizardNext = () => ({
    type: APP_V2_WIZARD_NEXT,
});

export const wizardDoneLoading = () => ({
    type: WIZARD_DONE_LOADING,
});

export const wizardPublishingOffer = bool => ({
    type: WIZARD_PUBLISHING_OFFER,
    bool,
});

export const appV2WizardBack = () => ({
    type: APP_V2_WIZARD_BACK,
});

export const wizardToggleNeedHelpModal = bool => ({
    type: WIZARD_TOGGLE_NEED_HELP_MODAL,
    bool,
});

export const toggleContactUsModal = () => ({
    type: TOGGLE_CONTACT_US_MODAL,
});

export const toggleCrossSellVideoModal = () => ({
    type: TOGGLE_CROSS_SELL_VIDEO_MODAL,
});

export const toggleBundleVideoModal = () => ({
    type: TOGGLE_BUNDLE_VIDEO_MODAL,
});

export const toggleVolumeDiscountVideoModal = () => ({
    type: TOGGLE_VOLUME_DISCOUNT_VIDEO_MODAL,
});

export const toggleMixAndMatchVideoModal = () => ({
    type: TOGGLE_MIX_AND_MATCH_VIDEO_MODAL,
});

export const toggleSelectProductsModal = () => ({
    type: TOGGLE_SELECT_PRODUCTS_MODAL,
});

export const toggleCrossSellSelectProductsModal = () => ({
    type: TOGGLE_CROSS_SELL_SELECT_PRODUCTS_MODAL,
});

export const toggleSelectCollectionsModal = () => ({
    type: TOGGLE_SELECT_COLLECTIONS_MODAL,
});

export const toggleCrossSellSelectCollectionsModal = () => ({
    type: TOGGLE_CROSS_SELL_SELECT_COLLECTIONS_MODAL,
});

export const toggleMnmSelectCollectionsModal = () => ({
    type: TOGGLE_MNM_SELECT_COLLECTIONS_MODAL,
});

export const toggleSelectTagsModal = () => ({
    type: TOGGLE_SELECT_TAGS_MODAL,
});

export const toggleCrossSellSelectTagsModal = () => ({
    type: TOGGLE_CROSS_SELL_SELECT_TAGS_MODAL,
});

export const approveSelectedProducts = () => ({
    type: APPROVE_SELECTED_PRODUCTS,
});

export const approveCrossSellSelectedProducts = () => ({
    type: APPROVE_CROSS_SELL_SELECTED_PRODUCTS,
});

export const approveSelectedCollections = () => ({
    type: APPROVE_SELECTED_COLLECTIONS,
});

export const approveCrossSellSelectedCollections = () => ({
    type: APPROVE_CROSS_SELL_SELECTED_COLLECTIONS,
});

export const approveMnmSelectedCollections = () => ({
    type: APPROVE_MNM_SELECTED_COLLECTIONS,
});

export const approveSelectedTags = () => ({
    type: APPROVE_SELECTED_TAGS,
});

export const approveCrossSellSelectedTags = () => ({
    type: APPROVE_CROSS_SELL_SELECTED_TAGS,
});

export const wizardVolumeAddTier = () => ({
    type: WIZARD_VOLUME_ADD_TIER,
});

export const selectOfferType = offerType => ({
    type: SELECT_OFFER_TYPE,
    offerType,
});

export const selectBundleType = bundleType => ({
    type: SELECT_BUNDLE_TYPE,
    bundleType,
});

export const wizardSelectMnmDiscountType = _type => ({
    type: WIZARD_SELECT_MNM_DISCOUNT_TYPE,
    _type,
});

export const selectPageType = pageType => ({
    type: SELECT_PAGE_TYPE,
    pageType,
});

export const appV2WizardSelectOfferPlacementMethod = method => ({
    type: APP_V2_WIZARD_SELECT_OFFER_PLACEMENT_METHOD,
    method,
});

export const selectTrigger = triggerType => ({
    type: SELECT_TRIGGER,
    triggerType,
});

export const selectContentType = contentType => ({
    type: SELECT_CONTENT_TYPE,
    contentType,
});

export const updateProductSearchText = text => ({
    type: UPDATE_PRODUCT_SEARCH_TEXT,
    text,
});

export const updateCollectionSearchText = text => ({
    type: UPDATE_COLLECTION_SEARCH_TEXT,
    text,
});

export const updateTagSearchText = text => ({
    type: UPDATE_TAG_SEARCH_TEXT,
    text,
});

export const wizardBundleAmountChange = text => ({
    type: WIZARD_BUNDLE_AMOUNT_CHANGE,
    text,
});

export const wizardMnmDiscountAmountChange = text => ({
    type: WIZARD_MNM_DISCOUNT_AMOUNT_CHANGE,
    text,
});

export const wizardMnmMinQtyChange = (idx, text) => ({
    type: WIZARD_MNM_MIN_QTY_CHANGE,
    idx,
    text,
});

export const wizardMnmTrashProductGroup = (idx) => ({
    type: WIZARD_MNM_TRASH_PRODUCT_GROUP,
    idx,
});

export const wizardVolumeQtyChange = (idx, qty) => ({
    type: WIZARD_VOLUME_QTY_CHANGE,
    idx,
    qty,
});

export const wizardVolumeDiscountTypeChange = (idx, text) => ({
    type: WIZARD_VOLUME_DISCOUNT_TYPE_CHANGE,
    idx,
    text,
});

export const wizardVolumeDiscountChange = (idx, text) => ({
    type: WIZARD_VOLUME_DISCOUNT_CHANGE,
    idx,
    text,
});

export const wizardVolumePopularChange = (idx, bool) => ({
    type: WIZARD_VOLUME_POPULAR_CHANGE,
    idx,
    bool,
});

export const wizardVolumeTrashTier = idx => ({
    type: WIZARD_VOLUME_TRASH_TIER,
    idx,
});

export const setSearchedProducts = json => ({
    type: SET_SEARCHED_PRODUCTS,
    json,
});

export const wizardSetTriggerStageUuid = uuid => ({
    type: WIZARD_SET_TRIGGER_STAGE_UUID,
    uuid,
});

export const wizardSetOfferStageUuid = uuid => ({
    type: WIZARD_SET_OFFER_STAGE_UUID,
    uuid,
});

export const wizardSetFinalizeOfferStartTime = time => ({
    type: WIZARD_SET_FINALIZE_OFFER_START_TIME,
    time,
});

export const wizardSetTriggerStageReady = (uuid, handle) => ({
    type: WIZARD_SET_TRIGGER_STAGE_READY,
    uuid,
    handle,
});

export const wizardSetOfferStageReady = (uuid, handle) => ({
    type: WIZARD_SET_OFFER_STAGE_READY,
    uuid,
    handle,
});

export const setBundleSearchedProducts = json => ({
    type: SET_BUNDLE_SEARCHED_PRODUCTS,
    json,
});

export const setSearchedCollections = json => ({
    type: SET_SEARCHED_COLLECTIONS,
    json,
});

export const setSearchedTags = edges => ({
    type: SET_SEARCHED_TAGS,
    edges,
});

export const setAllTags = json => ({
    type: SET_ALL_TAGS,
    json,
});

export const toggleSelectProduct = id => ({
    type: TOGGLE_SELECT_PRODUCT,
    id,
});

export const toggleSelectCollection = id => ({
    type: TOGGLE_SELECT_COLLECTION,
    id,
});

export const toggleSelectTag = id => ({
    type: TOGGLE_SELECT_TAG,
    id,
});

export const removeSelectedProduct = id => ({
    type: REMOVE_SELECTED_PRODUCT,
    id,
});

export const removeSelectedCollection = id => ({
    type: REMOVE_SELECTED_COLLECTION,
    id,
});

export const removeSelectedTag = id => ({
    type: REMOVE_SELECTED_TAG,
    id,
});

export const wizardBundleSelectProduct = id => ({
    type: WIZARD_BUNDLE_SELECT_PRODUCT,
    id,
});

export const wizardChooseBundleProduct = idx => ({
    type: WIZARD_CHOOSE_BUNDLE_PRODUCT,
    idx,
});

export const wizardBundleRemoveProduct = idx => ({
    type: WIZARD_BUNDLE_REMOVE_PRODUCT,
    idx,
});

export const sendingSupportRequest = bool => ({
    type: SENDING_SUPPORT_REQUEST,
    bool,
});

export const wizardSetInvalidSelectPage = bool => ({
    type: WIZARD_SET_INVALID_SELECT_PAGE,
    bool,
});

export const wizardSetInvalidSelectTrigger = bool => ({
    type: WIZARD_SET_INVALID_SELECT_TRIGGER,
    bool,
});

export const wizardSetInvalidSelectOffer = bool => ({
    type: WIZARD_SET_INVALID_SELECT_OFFER,
    bool,
});

export const wizardBundleCloseSelectProductsModal = () => ({
    type: WIZARD_BUNDLE_CLOSE_SELECT_PRODUCTS_MODAL,
});

export const wizardBundleAddProduct = () => ({
    type: WIZARD_BUNDLE_ADD_PRODUCT,
});

export const wizardStatus = text => ({
    type: WIZARD_STATUS,
    text,
});

export const wizardPreviewReady = () => ({
    type: WIZARD_PREVIEW_READY,
});

export const wizardCreateAnotherOffer = () => ({
    type: WIZARD_CREATE_ANOTHER_OFFER,
});

export const wizardCollectionsAreUploaded = () => ({
    type: WIZARD_COLLECTIONS_ARE_UPLOADED,
});

export const wizardTogglePlacementMethodCollapsible = () => ({
    type: WIZARD_TOGGLE_PLACEMENT_METHOD_COLLAPSIBLE,
});

export const wizardShowFallback = () => ({
    type: WIZARD_SHOW_FALLBACK,
});

export const wizardSetCreateStoreJsUuid = uuid => ({
    type: WIZARD_SET_CREATE_STORE_JS_UUID,
    uuid,
});

export const wizardPreviewProgress = progress => ({
    type: WIZARD_PREVIEW_PROGRESS,
    progress,
});

export const wizardSetOfferAttributes = offer => ({
    type: WIZARD_SET_OFFER_ATTRIBUTES,
    offer,
});

export const setOfferPlacementAndOs2 = json => ({
    type: SET_OFFER_PLACEMENT_AND_OS2,
    json,
});

export const setEnableZoorixModalOpen = bool => ({
    type: SET_ENABLE_ZOORIX_MODAL_OPEN,
    bool,
});

export const wizardSetZoorixEnabledLoading = bool => ({
    type: WIZARD_SET_ZOORIX_ENABLED_LOADING,
    bool,
});

export const wizardEnablingZoorix = bool => ({
    type: WIZARD_ENABLING_ZOORIX,
    bool,
});

export const wizardSetZoorixEnabled = bool => ({
    type: WIZARD_SET_ZOORIX_ENABLED,
    bool,
});

export const wizardSetOfferCreationTimeoutId = id => ({
    type: WIZARD_SET_OFFER_CREATION_TIMEOUT_ID,
    id,
});

const textChangeInnerFunction = _debounce(dispatch => dispatch(selectProductsApi()), 1000);
export function onProductSearchTextChange(text) {
    return (dispatch, getState) => {
        dispatch(updateProductSearchText(text));
        textChangeInnerFunction(dispatch);
    }
}

const bundleTextChangeInnerFunction = _debounce(dispatch => dispatch(searchBundleProductsApi()), 1000);
export function wizardBundleSelectProductTextChange(text) {
    return (dispatch, getState) => {
        dispatch(updateProductSearchText(text));
        bundleTextChangeInnerFunction(dispatch);
    }
}

const collectionTextChangeInnerFunction = _debounce(dispatch => dispatch(searchCollectionsApi()), 1000);
export function collectionSearchTextChange(text) {
    return (dispatch, getState) => {
        dispatch(updateCollectionSearchText(text));
        collectionTextChangeInnerFunction(dispatch);
    }
}

export function tagSearchTextChange(text) {
    return (dispatch, getState) => {
        dispatch(updateTagSearchText(text));
        dispatch(searchTags());
    }
}

export function selectTriggerAndSearch(triggerType) {
    return (dispatch, getState) => {
        dispatch(selectTrigger(triggerType));
        const state = getState();
        switch (triggerType) {
            case 'specific_products':
                dispatch(updateProductSearchText(state.appV2Wizard.searchText || ''));
                textChangeInnerFunction(dispatch);
                break;
            case 'collections':
                dispatch(updateCollectionSearchText(state.appV2Wizard.searchText || ''));
                collectionTextChangeInnerFunction(dispatch);
                break;
            case 'tags':
                dispatch(updateTagSearchText(state.appV2Wizard.searchText || ''));
                dispatch(searchTags());
                break;
            default:
                break;
        }
    }
}

export function selectCrossSellContentAndSearch(contentType) {
    return (dispatch, getState) => {
        dispatch(selectContentType(contentType));
        const state = getState();
        switch (contentType) {
            case 'specific_products':
                dispatch(updateProductSearchText(state.appV2Wizard.searchText || ''));
                textChangeInnerFunction(dispatch);
                break;
            case 'collections':
                dispatch(updateCollectionSearchText(state.appV2Wizard.searchText || ''));
                collectionTextChangeInnerFunction(dispatch);
                break;
            case 'tags':
                dispatch(updateTagSearchText(state.appV2Wizard.searchText || ''));
                dispatch(searchTags());
                break;
            default:
                break;
        }
    }
}

export function selectProductsApi() {
    return async (dispatch, getState) => {
        const state = getState();
        const response = await postPayload('products/search', {
            text: state.appV2Wizard.searchText,
        }, state)
        if (response.ok) {
            const json = await response.json();
            dispatch(setSearchedProducts(json));
        } else {
            console.log('selectProductsApi failure');
        }
    }
}

export const wizardCheckIfReadyToCreateOffer = () => async (dispatch, getState) => {
    const state = getState();
    dispatch(wizardStatus(
        state.appV2Wizard.stage4FetchComplete ?
            (state.appV2Wizard.stage5FetchComplete ? 'Fetching products complete' : 'Fetching offer products')
            : (state.appV2Wizard.stage5FetchComplete ? 'Fetching trigger products' : 'Fetching trigger and offer products')));
    const ready = state.appV2Wizard.stage4FetchComplete && state.appV2Wizard.stage5FetchComplete;
    if (ready) {
        dispatch(wizardStatus('Creating offer'));
        if (state.appV2Wizard.offerType === 'cross_sell') {
            dispatch(wizardCreateCrossSell());
        } else if (state.appV2Wizard.offerType === 'volume_discount') {
            dispatch(wizardCreateVolumeDiscount());
        } else if (state.appV2Wizard.offerType === 'bundle') {
            dispatch(wizardCreateBundle());
        } else if (state.appV2Wizard.offerType === 'mix_and_match') {
            if (state.appV2Wizard.collectionsAreUploaded) {
                dispatch(wizardCreateMixAndMatch());
            } else {
                dispatch(wizardStatus('Fetching collections'));
                setTimeout(() => dispatch(wizardCheckIfReadyToCreateOffer()), 500);
            }
        }
    } else {
        setTimeout(() => dispatch(wizardCheckIfReadyToCreateOffer()), 500);
    }
}

export const adminTrack = (event, props, callback) => async (dispatch, getState) => {
    const state = getState();
    if (state.data.shopName) {
        await postPayload('segment/track', {
            event,
            props,
        }, state)
        if (callback) callback();
    } else {
        window.setTimeout(() => dispatch(adminTrack(event, props, callback)), 1000);
    }
}

export const getOfferPlacementAndOs2 = () => async (dispatch, getState) => {
    const state = getState();
    const res = await postPayload('data/get_os2_and_offer_placement', {}, state);
    if (res.ok) {
        const json = await res.json();
        dispatch(setOfferPlacementAndOs2(json));
    } else {
        console.log('getOfferPlacementAndOs2 failed');
    }
}

export const getZoorixEnabled = () => async (dispatch, getState) => {
    const state = getState();
    const res = await fetch(`https://is-m-enabled.zoorix.com/is-zoorix-M-app-blocks-enabled?sn=${state.data.shopName}`);
    if (res.ok) {
        const json = await res.json();
        dispatch(wizardSetZoorixEnabled(json.a));
        dispatch(setPasswordEnabled(json.p));
        dispatch(setEnableZoorixModalOpen(json.p || !json.a));
        dispatch(wizardSetZoorixEnabledLoading(false));
    } else {
        console.log('getZoorixEnabled failed');
    }
    // const res = await postPayload('data/get_zoorix_enabled', {}, state);
    // if (res.ok) {
    //     const json = await res.json();
    //     dispatch(wizardSetZoorixEnabled(json.zoorix_enabled));
    //     dispatch(setEnableZoorixModalOpen(!json.zoorix_enabled));
    //     dispatch(wizardSetZoorixEnabledLoading(false));
    // } else {
    //     console.log('getZoorixEnabled failed');
    // }
}

export const wizardToggleZoorixEnabled = () => async (dispatch, getState) => {
    dispatch(wizardSetZoorixEnabledLoading(true));
    const state = getState();
    const res = await postPayload('data/set_zoorix_enabled', {enable: !state.appV2Wizard.zoorixIsEnabled}, state);
    if (res.ok) {
        dispatch(wizardSetZoorixEnabled(!state.appV2Wizard.zoorixIsEnabled));
    } else {
        console.log('wizardToggleZoorixEnabled failed');
    }
    dispatch(wizardSetZoorixEnabledLoading(false));
}

const enableClickedToEventName = {
    enable: 'onboarding_wizard_enable_zoorix_clicked',
    disable: 'onboarding_wizard_disable_zoorix_clicked',
    unknown: 'onboarding_wizard_enable_slash_disable_zoorix_clicked',
}

export const wizardEnableZoorixClicked = event => async (dispatch, getState) => {
    dispatch(wizardEnablingZoorix(true));
    const state = getState();
    dispatch(adminTrack(enableClickedToEventName[event], {
        offer_type: state.appV2Wizard.offerType,
    }, async () => {
        window.open(`https://${state.data.shopName}/admin/themes/current/editor?context=apps`, '_blank');
        // const res = await postPayload('data/set_zoorix_enabled', {enable}, state);
        // if (res.ok) {
        //     dispatch(wizardSetZoorixEnabled(enable));
        // } else {
        //     dispatch(adminTrack(enable ? 'onboarding_wizard_enable_zoorix_failed' : 'onboarding_wizard_disable_zoorix_failed', {
        //         offer_type: state.appV2Wizard.offerType,
        //     }, () => window.open(`https://${state.data.shopName}/admin/themes/current/editor?context=apps`, '_blank')));
        // }
        dispatch(wizardEnablingZoorix(false));
    }));
}

export const wizardCreateStoreJsDone = uuid => async (dispatch, getState) => {
    const state = getState();
    if (state.appV2Wizard.createStoreJsUuid === uuid) {
        dispatch(wizardPreviewReady());
        console.log('clearing timeout id:', state.appV2Wizard.offerCreationTimeoutId);
        clearTimeout(state.appV2Wizard.offerCreationTimeoutId);
        dispatch(adminTrack('onboarding_wizard_preview_ready', {
            offer_type: state.appV2Wizard.offerType,
            time_since_finalize: Date.now() / 1000 - state.appV2Wizard.finalizeOfferStartTime,
        }));
    }
}

export const wizardBundleAddProductAndChoose = () => async (dispatch, getState) => {
    await dispatch(wizardBundleAddProduct());
    const state = getState();
    dispatch(wizardChooseBundleProduct(state.appV2Wizard.bundle.products.length - 1));
    dispatch(searchBundleProductsApi());
}

export const wizardCreateStoreJsProgress = data => async (dispatch, getState) => {
    const state = getState();
    if (state.appV2Wizard.createStoreJsUuid === data.uuid) {
        dispatch(wizardPreviewProgress(data.progress));
    }
}

export const appV2WizardSelectOfferType = () => async (dispatch, getState) => {
    const state = getState();
    if (state.appV2Wizard.offerType === 'cross_sell' || state.appV2Wizard.offerType === 'volume_discount') {
        if (!['specific_products', 'collections', 'tags'].includes(state.appV2Wizard.triggerType)) {
            dispatch(selectTrigger('specific_products'));
        }
    } else if (state.appV2Wizard.offerType === 'bundle') {
        if (!['bundle_items', 'collections', 'tags'].includes(state.appV2Wizard.triggerType)) {
            dispatch(selectTrigger('bundle_items'));
        }
    } else if (state.appV2Wizard.offerType === 'mix_and_match') {
        if (!['mnm_items', 'collections'].includes(state.appV2Wizard.triggerType)) {
            dispatch(selectTrigger('mnm_items'));
        }
        dispatch(checkIfCollectionsAreUploaded(true));
    } else if (state.appV2Wizard.offerType === 'bogo') {
        dispatch(selectTrigger('bogo_items'));
    }
    dispatch(appV2WizardNext());
    dispatch(adminTrack('onboarding_wizard_offer_selected', {
        offer_type: state.appV2Wizard.offerType,
        trigger_type: state.appV2Wizard.triggerType,
    }));
}

export const checkIfCollectionsAreUploaded = (invokeJob) => async (dispatch, getState) => {
    const state = getState();
    let res = await postPayload('data/are_collections_uploaded', {}, state);
    if (res.ok) {
        const json = await res.json();
        if (json.collections_uploaded) {
            dispatch(wizardCollectionsAreUploaded());
        } else {
            if (invokeJob) {
                res = await postPayload('data/save_and_upload_collections', {}, state);
                console.log(`checkIfCollectionsAreUploaded save_and_upload_collections ok:${res.ok}`)
            }
            setTimeout(() => dispatch(checkIfCollectionsAreUploaded(false)), 1000)
        }
    } else {
        console.log('checkIfCollectionsAreUploaded fail')
    }
}

export const wizardValidateSelectPage = () => async (dispatch, getState) => {
    const state = getState();
    if (state.appV2Wizard.offerType === 'cross_sell') {
        if (state.appV2Wizard.pageType['product'] || state.appV2Wizard.pageType['cart']) {
            dispatch(adminTrack('onboarding_wizard_page_selected', {
                offer_type: state.appV2Wizard.offerType,
                page_type_product: !!state.appV2Wizard.pageType['product'],
                page_type_cart: !!state.appV2Wizard.pageType['cart'],
            }));
            dispatch(appV2WizardNext());
        } else {
            dispatch(wizardSetInvalidSelectPage(true));
        }
    } else if (['volume_discount', 'bundle', 'mix_and_match', 'bogo'].includes(state.appV2Wizard.offerType)) {

        if (state.appV2Wizard.pageType['product-main'] || state.appV2Wizard.pageType['product-bottom'] ||
            state.appV2Wizard.pageType['cart-top'] || state.appV2Wizard.pageType['cart-bottom']) {
            dispatch(adminTrack('onboarding_wizard_page_selected', {
                offer_type: state.appV2Wizard.offerType,
                page_type_product_main: !!state.appV2Wizard.pageType['product-main'],
                page_type_product_bottom: !!state.appV2Wizard.pageType['product-bottom'],
                page_type_cart_top: !!state.appV2Wizard.pageType['cart-top'],
                page_type_cart_bottom: !!state.appV2Wizard.pageType['cart-bottom'],
            }));
            dispatch(appV2WizardNext());
        } else {
            dispatch(wizardSetInvalidSelectPage(true));
        }
    }
}

export const setOfferPlacement = () => async (dispatch, getState) => {
    const state = getState();
    const res = await postPayload('data/set_offer_placement_method', {
        offer_placement_method: state.appV2Wizard.offerPlacementMethod,
    }, state);
    if (res.ok) {
        await postPayload('admin_v2/create_store_js', {}, state);
    } else {
        console.log('setOfferPlacement failed');
    }
}

export const wizardCreateCrossSell = () => async (dispatch, getState) => {
    const state = getState();
    const triggerIds = getConfirmedIds(state, 'triggerType', 'confirmedSelectedProducts',
        'confirmedSelectedCollections', 'confirmedSelectedTags');
    const contentIds = getConfirmedIds(state, 'contentType', 'confirmedCrossSellSelectedProducts',
        'confirmedCrossSellSelectedCollections', 'confirmedCrossSellSelectedTags')
    const res = await postPayload('mappings/save_new_from_wizard', {
        on_pages: state.appV2Wizard.pageType,
        trigger_type: state.appV2Wizard.triggerType,
        trigger_ids: triggerIds,
        content_type: state.appV2Wizard.contentType,
        content_ids: contentIds,
        preview_mode: true,
    }, state)
    if (res.ok) {
        const json = await res.json();
        dispatch(wizardSetOfferAttributes(json.offer));
        dispatch(closeWizard());
        dispatch(wizardCreateStoreJs());
    }
}

export const wizardCreateVolumeDiscount = () => async (dispatch, getState) => {
    const state = getState();
    const triggerIds = getConfirmedIds(state, 'triggerType', 'confirmedSelectedProducts',
        'confirmedSelectedCollections', 'confirmedSelectedTags');
    const res = await postPayload('volume_discount/create_from_wizard', {
        on_pages: state.appV2Wizard.pageType,
        trigger_type: state.appV2Wizard.triggerType,
        trigger_id: triggerIds[0],
        vd: state.appV2Wizard.vd,
        preview_mode: true,
    }, state)
    if (res.ok) {
        const json = await res.json();
        dispatch(wizardSetOfferAttributes(json.offer));
        dispatch(closeWizard());
        dispatch(wizardCreateStoreJs());
    }
}

export const wizardCreateBundle = () => async (dispatch, getState) => {
    const state = getState();
    let triggerIds;
    if (state.appV2Wizard.triggerType === 'bundle_items') {
        // Do nothing
    } else {
        triggerIds = getConfirmedIds(state, 'triggerType', 'confirmedSelectedProducts',
            'confirmedSelectedCollections', 'confirmedSelectedTags');
    }
    const res = await postPayload('bundle/create_from_wizard', {
        on_pages: state.appV2Wizard.pageType,
        trigger_type: state.appV2Wizard.triggerType,
        bundle: state.appV2Wizard.bundle,
        bundle_type: state.appV2Wizard.bundleType,
        trigger_ids: triggerIds,
        preview_mode: true,
    }, state)
    if (res.ok) {
        const json = await res.json();
        dispatch(wizardSetOfferAttributes(json.offer));
        dispatch(closeWizard());
        dispatch(wizardCreateStoreJs());
    }
}

export const wizardCreateMixAndMatch = () => async (dispatch, getState) => {
    const state = getState();
    const res = await postPayload('mix_and_match/create_from_wizard', {
        on_pages: state.appV2Wizard.pageType,
        trigger_type: state.appV2Wizard.triggerType,
        mnm: state.appV2Wizard.mnm,
        trigger_collections: state.appV2Wizard.confirmedSelectedCollections,
        preview_mode: true,
    }, state)
    if (res.ok) {
        const json = await res.json();
        dispatch(wizardSetOfferAttributes(json.offer));
        dispatch(closeWizard());
        dispatch(wizardCreateStoreJs());
    }
}

export const wizardCreateStoreJs = () => async (dispatch, getState) => {
    const state = getState();
    dispatch(wizardStatus('Creating store files'));
    const res = await postPayload('admin_v2/create_store_js', {}, state);
    if (res.ok) {
        const json = await res.json();
        dispatch(wizardSetCreateStoreJsUuid(json.uuid));
    }
}

function getConfirmedIds(state, typeField, productsField, collectionsField, tagsField) {
    let ids = [];
    if (state.appV2Wizard[typeField] === 'specific_products') {
        ids = state.appV2Wizard[productsField].map(p => p.id);
    } else if (state.appV2Wizard[typeField] === 'collections') {
        ids = state.appV2Wizard[collectionsField].map(c => c.id);
    } else if (state.appV2Wizard[typeField] === 'tags') {
        ids = state.appV2Wizard[tagsField];
    }
    return ids;
}

export function wizardFetchStage4Products() {
    return async (dispatch, getState) => {
        const stage4Uuid = uuid4();
        const state = getState();
        await dispatch(wizardSetTriggerStageUuid(stage4Uuid));
        if (['bundle_items', 'mnm_items', 'bogo_items'].includes(state.appV2Wizard.triggerType)) {
            dispatch(wizardSetTriggerStageReady(stage4Uuid));
            dispatch(adminTrack('onboarding_wizard_trigger_type_selected', {
                offer_type: state.appV2Wizard.offerType,
                trigger_type: state.appV2Wizard.triggerType,
            }));
            dispatch(appV2WizardNext());
            return;
        }
        const ids = getConfirmedIds(state, 'triggerType', 'confirmedSelectedProducts',
            'confirmedSelectedCollections', 'confirmedSelectedTags');
        if (ids.length === 0) {
            dispatch(wizardSetInvalidSelectTrigger(true));
            return;
        }
        dispatch(adminTrack('onboarding_wizard_trigger_type_selected', {
            offer_type: state.appV2Wizard.offerType,
            trigger_type: state.appV2Wizard.triggerType,
        }));
        dispatch(appV2WizardNext());
        const response = await postPayload('admin_v2/fetch_products_for_wizard', {
            uuid: stage4Uuid,
            ids_type: state.appV2Wizard.triggerType,
            ids,
            stage: 'trigger',
        }, state)
        if (response.ok) {
            console.log('wizardFetchStage4Products success');
        } else {
            console.log('wizardFetchStage4Products failure');
        }
    }
}

const dispatchOfferCreationTimeout = dispatch => dispatch(wizardSetOfferCreationTimeoutId(
    setTimeout(() => {
        dispatch(adminTrack('onboarding_wizard_finalize_offer_timeout_reached', {}));
        dispatch(wizardShowFallback());
    }, 15_000)));

export function wizardFetchStage5Products() {
    return async (dispatch, getState) => {
        const stage5Uuid = uuid4();
        const state = getState();
        await dispatch(wizardSetOfferStageUuid(stage5Uuid));
        dispatch(wizardSetFinalizeOfferStartTime(Date.now() / 1000));

        if (state.appV2Wizard.offerType === 'volume_discount') {
            dispatch(wizardSetOfferStageReady(stage5Uuid));
            dispatch(wizardCheckIfReadyToCreateOffer());
            dispatch(adminTrack('onboarding_wizard_finalize_offer', {
                offer_type: state.appV2Wizard.offerType,
            }));
            dispatch(appV2WizardNext());
            dispatchOfferCreationTimeout(dispatch);
            return;
        }

        let ids;
        let ids_type;
        if (state.appV2Wizard.offerType === 'cross_sell') {
            ids_type = state.appV2Wizard.contentType;
            ids = getConfirmedIds(state, 'contentType', 'confirmedCrossSellSelectedProducts',
                'confirmedCrossSellSelectedCollections', 'confirmedCrossSellSelectedTags');
        } else if (state.appV2Wizard.offerType === 'bundle') {
            ids_type = 'specific_products';
            ids = state.appV2Wizard.bundle.products.filter(p => !p.empty).map(p => p.id);
        } else if (state.appV2Wizard.offerType === 'mix_and_match') {
            ids_type = 'collections';
            ids = state.appV2Wizard.mnm.product_groups.filter(pg => pg.group_type === 'collection').map(p => p.id);
        }

        if (ids.length === 0) {
            dispatch(wizardSetInvalidSelectOffer(true));
            return;
        }
        dispatch(wizardCheckIfReadyToCreateOffer());
        dispatch(adminTrack('onboarding_wizard_finalize_offer', {
            offer_type: state.appV2Wizard.offerType,
        }));
        dispatch(appV2WizardNext());
        dispatchOfferCreationTimeout(dispatch);
        const response = await postPayload('admin_v2/fetch_products_for_wizard', {
            uuid: stage5Uuid,
            ids_type,
            ids,
            stage: 'config_offer',
        }, state)
        if (response.ok) {
            console.log('wizardFetchStage5Products success');
        } else {
            console.log('wizardFetchStage5Products failure');
        }
    }
}

export function wizardHideEnableZoorix() {
    return async (dispatch, getState) => {
        dispatch(setEnableZoorixModalOpen(false));
        const state = getState();
        const response = await postPayload('admin_settings/toggle_hide_wizard_enable_zoorix', {
            bool: true,
        }, state)
        if (response.ok) {
            console.log('wizardHideEnableZoorix success');
        } else {
            console.log('wizardHideEnableZoorix failure');
        }
    }
}

export const wizardPreviewOffer = () => async (dispatch, getState) => {
    const state = getState();
    let res = await postPayload('data/get_zoorix_enabled', {}, state);
    if (res.ok) {
        const json = await res.json();
        if (!json.zoorix_enabled) {
            dispatch(wizardSetZoorixEnabled(false));
            dispatch(setEnableZoorixModalOpen(true));
            return;
        }
    }
    dispatch(adminTrack('onboarding_wizard_preview', {}));
    res = await postPayload('admin_v2/preview_offer', {}, state);
    if (res.ok) {
        const json = await res.json();
        const one_time_token_id = json.one_time_token_id;
        window.open(`https://${state.data.shopName}/products/${state.appV2Wizard.previewProductHandle}?shown_ott=${one_time_token_id}&zrx_preview_mode=true`, '_blank')
    } else {
        dispatch(adminTrack('onboarding_wizard_preview_failed_to_gen_ott', {}));
        window.open(`https://${state.data.shopName}/products/${state.appV2Wizard.previewProductHandle}?zrx_preview_mode=true`, '_blank')
    }
}

export const wizardDone = () => async (dispatch, getState) => {
    dispatch(wizardDoneLoading());
    dispatch(adminTrack('onboarding_wizard_done', {}, () => {
        dispatch(closeWizard(() => {
            dispatch(postResync(() => window.location.reload()));
        }));
    }));
}

export const wizardFallback = () => async (dispatch, getState) => {
    dispatch(wizardDoneLoading());
    dispatch(adminTrack('onboarding_wizard_fallback', {}, () => {
        dispatch(closeWizard(() => {
            dispatch(postResync(() => window.location.reload()));
        }));
    }));
}

const offerTypeToPublishEndpoint = {
    volume_discount: 'volume_discount/switch_preview',
    cross_sell: 'mappings/switch_preview',
    bundle: 'bundle/switch_preview',
    mix_and_match: 'mix_and_match/switch_preview',
}

export const wizardPublish = () => async (dispatch, getState) => {
    dispatch(wizardPublishingOffer(true));
    const state = getState();
    let res = await postPayload('data/get_zoorix_enabled', {}, state);
    if (res.ok) {
        const json = await res.json();
        if (!json.zoorix_enabled) {
            dispatch(wizardSetZoorixEnabled(false));
            dispatch(setEnableZoorixModalOpen(true));
            dispatch(wizardPublishingOffer(false));
            return;
        }
    }
    dispatch(adminTrack('onboarding_wizard_publish', {}, async () => {
        const state = getState();
        const endpoint = offerTypeToPublishEndpoint[state.appV2Wizard.offerType];
        const res = await postPayload(endpoint, {
            preview_mode: false,
            id: state.appV2Wizard.serverOfferAttributes.id,
        }, state);
        if (res.ok) {
            dispatch(postResync(() => window.location.reload()));
        } else {
            console.log('wizardPublish failed')
        }
        dispatch(wizardPublishingOffer(false));
    }));
}

export const wizardAbort = () => async (dispatch, getState) => {
    dispatch(wizardDoneLoading());
    dispatch(adminTrack('onboarding_wizard_abort', {}, () => {
        dispatch(closeWizard(() => {
            dispatch(postResync(() => window.location.reload()));
        }));
    }));
}

export function searchBundleProductsApi() {
    return async (dispatch, getState) => {
        const state = getState();
        const response = await postPayload('products/search', {
            text: state.appV2Wizard.searchText || '',
        }, state)
        if (response.ok) {
            const json = await response.json();
            dispatch(setBundleSearchedProducts(json));
        } else {
            console.log('searchBundleProductsApi failure');
        }
    }
}

export function searchCollectionsApi() {
    return async (dispatch, getState) => {
        const state = getState();
        const res = await postPayload('collections/search', {
            text: state.appV2Wizard.searchText,
        }, state);
        if (res.ok) {
            const json = await res.json();
            dispatch(setSearchedCollections(json));
        } else {
            console.log('searchCollectionsApi failure');
        }
    }
}

export function searchTags() {
    return async (dispatch, getState) => {
        const state = getState();
        const text = state.appV2Wizard.searchText.toLowerCase();
        const edges = state.appV2Wizard.allTags.filter(edge => edge.node.toLowerCase().includes(text)).slice(0, 10);
        if (!edges.find(edge => edge.node.toLowerCase() === text)) {
            edges.push({node: text});
        }
        dispatch(setSearchedTags(edges));
    }
}

export function getAllTags(shopName, token) {
    return async (dispatch, getState) => {
        const res = await postPayload('tags/get_all', {
            shop_name: shopName,
            token,
        });
        if (res.ok) {
            const json = await res.json();
            dispatch(setAllTags(json));
        } else {
            console.log('getAllTags failure');
        }
    }
}

